import React from "react";
import BatteryListTable from "../Components/BatteryListTable";
import { getSohCustomRenderers, getSohCSVFileName } from "./SOHDetailsTableConfig";

const SOHDetailsTable = ({ globalFilters = {}, additionalFilters = [] }) => (
  <BatteryListTable
    schemaPath="SOHDetails"
    customRenderersFn={getSohCustomRenderers}
    getCSVFileName={getSohCSVFileName}
    defaultSortColumn="sohEst"
    globalFilters={globalFilters}
    additionalFilters={additionalFilters}
    pageSize={50}
  />
);

export default SOHDetailsTable;
